import { Button, Chip, TableCell, TableRow, Typography } from "@mui/material";
import { Invoice } from "../../types/invoice";
import { getInvoiceChipColor, formatInvoiceDate, formatInvoiceAmount } from "../../features/finances/utils/invoiceUtils";

export interface InvoiceTableRowProps {
  invoice: Invoice;
  isMobile?: boolean;
}

function InvoiceTableRow({ invoice, isMobile = false }: InvoiceTableRowProps) {
  return (
    <TableRow
      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
    >
      <TableCell component="th" scope="row">
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.95rem" } }}>
          {invoice.number}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.95rem" } }}>
          {formatInvoiceDate(invoice.created)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.95rem" } }}>
          {formatInvoiceDate(invoice.due_date)}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.95rem" } }}>
          {invoice.currency.toUpperCase()}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography sx={{ fontSize: { xs: "0.8rem", sm: "0.95rem" } }}>
          {formatInvoiceAmount(invoice.total)}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={invoice.status.toUpperCase()}
          color={getInvoiceChipColor(invoice.status)}
          size={isMobile ? "small" : "small"}
          variant="outlined"
          sx={{
            fontSize: { xs: "0.65rem", sm: "0.75rem" },
            height: { xs: 24, sm: 28 },
            "& .MuiChip-label": {
              px: { xs: 1, sm: 1.5 },
            },
          }}
        />
      </TableCell>
      <TableCell>
        {invoice.status === "paid" ? (
          <Button
            variant="contained"
            size={isMobile ? "small" : "small"}
            href={invoice.invoice_pdf}
            sx={{
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
              px: { xs: 1, sm: 2 },
              py: { xs: 0.5, sm: 1 },
              minWidth: { xs: 70, sm: "auto" },
            }}
          >
            Download
          </Button>
        ) : (
          <Button
            variant="contained"
            size={isMobile ? "small" : "small"}
            color="secondary"
            href={invoice.hosted_invoice_url}
            sx={{
              fontSize: { xs: "0.7rem", sm: "0.875rem" },
              px: { xs: 1, sm: 2 },
              py: { xs: 0.5, sm: 1 },
              minWidth: { xs: 70, sm: "auto" },
            }}
          >
            Checkout
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default InvoiceTableRow;

